import { render } from "./InvoicesTable.vue?vue&type=template&id=47e3bab1"
import script from "./InvoicesTable.vue?vue&type=script&lang=ts"
export * from "./InvoicesTable.vue?vue&type=script&lang=ts"

import "./InvoicesTable.vue?vue&type=style&index=0&id=47e3bab1&lang=scss"
script.render = render

export default script